import * as types from "../actionTypes";
import initialState from "../../../reducers/initialState";
import { combineReducers } from "redux";

const activityFieldsReducer = (state = initialState.activityFields, action) => {
  switch (action.type) {
    case types.LOAD_ACTIVITY_FIELDS_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true, loaded: false };
      return result;
    }
    case types.LOAD_ACTIVITY_FIELDS_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: true, ids: action.result };
      return result;
    }
    case types.LOAD_ACTIVITY_FIELDS_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...result[key], loading: false, loaded: false };
      return result;
    }

    case types.UPDATE_ACTIVITY_FIELDS_STARTED: {
      const { partnerId } = action;
      let result = { ...state };
      result[partnerId] = { ...result[partnerId], loading: true, loaded: false };
      return result;
    }
    case types.UPDATE_ACTIVITY_FIELDS_SUCCEEDED: {
      const { partnerId, ids } = action;
      let result = { ...state };
      result[partnerId] = { ...result[partnerId], loading: false, loaded: true, ids: ids };
      return result;
    }

    case types.UPDATE_ACTIVITY_FIELDS_FAILED: {
      const { partnerId } = action;
      let result = { ...state };
      result[partnerId] = { ...result[partnerId], loading: true, loaded: true };
      return result;
    }

    default:
      return state;
  }
};

export default combineReducers({
  list: activityFieldsReducer
});
